export const setTempFavoriteShopAction = (shopId, isFavorite) => {
    return {
        type: 'SET_TEMP_FAV_SHOP',
        isFavorite,
        shopId
    }
}